// Deliberately empty: production media must resolve through Amplify Storage
// signed S3 URLs. Do not add legacy public URLs here as a visual fallback.
const MEDIA_FALLBACK_URLS = {};

const warnedKeys = new Set();

function normalizeMediaKey(s3Key) {
  const key = typeof s3Key === "string" ? s3Key.trim() : "";
  if (!key) return "";
  return key.replace(/^s3:\/\/[^/]+\//i, "").replace(/^\/+/, "");
}

function isDiagnosticContext() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (
    process.env.NODE_ENV === "development" ||
    host === "windroos.boss-tech.nl" ||
    host === "localhost" ||
    host === "127.0.0.1"
  );
}

export function getMediaFallbackUrl(s3Key) {
  const key = normalizeMediaKey(s3Key);
  return MEDIA_FALLBACK_URLS[key] || null;
}

// Renderers call this exactly once per s3Key when they switch to the fallback
// URL because the signed-S3 fetch failed in the browser. The intent is to make
// any regression of the signed-media pipeline loud in the UAT console, since
// the fallback would otherwise hide the failure visually.
export function reportFallbackInUse(s3Key, reason) {
  const key = normalizeMediaKey(s3Key);
  if (!key || warnedKeys.has(key)) return;
  warnedKeys.add(key);
  if (!isDiagnosticContext()) return;
  console.warn(
    `[Windroos media] using UAT fallback for ${key} — signed S3 should serve this asset directly; investigate before production`,
    { s3Key: key, reason }
  );
}
